import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { UITypes } from "types"

import useCustomerEditModal from "hooks/useCustomerEditModal"

const Container = styled.div`
  text-decoration: underline;
  color: #2db2c8;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`

interface CustomerEmailProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const CustomerEmail = ({ cell }: CustomerEmailProps) => {
  const { onShowEditCustomerModal, renderEditCustomerModal } = useCustomerEditModal()
  const customerEmail = cell.getValue().value as string
  const customerId: number | null = cell.row.original.rowSettings.item.client_id
  const isInstalled = cell.row.original.rowSettings.item.phisical_status === "installed"

  const handleCustomerClick = () => {
    if (!customerId) return
    onShowEditCustomerModal(customerId)
  }

  const getCustomerEmail = () => {
    if (!isInstalled) {
      return ""
    }

    if (customerEmail && customerId) {
      return customerEmail
    }

    return ""
  }

  return (
    <>
      <Container onClickCapture={handleCustomerClick}>{getCustomerEmail()}</Container>
      {renderEditCustomerModal()}
    </>
  )
}
